exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".permissions-border-left[data-v-ef03e39c] {\n  border-left: solid 1px #bfbfbf;\n}\n.border-top-none[data-v-ef03e39c] {\n  border-top: none;\n}\n.alert-min-height[data-v-ef03e39c] {\n  min-height: 4rem;\n}", ""]);

// exports
